import { ItemService } from './../services/item.service';
import { Component, OnInit } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
  selector: 'app-chart',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.css']
})
export class ChartComponent implements OnInit {
  
  chart = [];
  seasonality_dates = ["01-01-2017", "01-02-2017", "01-03-2017", "01-04-2017", "01-05-2017", "01-06-2017", "01-07-2017", "01-08-2017", "01-09-2017", "01-10-2017", "01-11-2017", "01-12-2017", "01-13-2017", "01-14-2017", "01-15-2017", "01-16-2017", "01-17-2017", "01-18-2017", "01-19-2017", "01-20-2017", "01-21-2017", "01-22-2017", "01-23-2017", "01-24-2017", "01-25-2017", "01-26-2017", "01-27-2017", "01-28-2017", "01-29-2017", "01-30-2017", "01-31-2017"];
  seasonality_spends = [127793399.92, 118556902.9358333, 129355844.8508333, 137898570.9858333, 138787891.3525, 140474365.2025, 147363699.6858333, 143043594.0683333, 130696390.735, 136258692.4516667, 137216900.5016667, 144403913.2016667, 143866983.135, 148948191.2183333, 144045775.2675, 126622242.8183333, 122269454.485, 123991097.135, 126203900.185, 126672492.535, 146079938.3683333, 144018501.5175, 129594563.1841667, 137416683.2683333, 156082107.0016667, 154530142.135, 156337617.4683333, 159085134.6016667, 147912885.9033333, 139701571.7175, 141309096.5683333];


  constructor(private itemService: ItemService) { }

  ngOnInit() {
    
    // const seasonality_dates = this.itemService.mydates;
    //   const seasonality_spends = this.itemService.myspends;

  

      // console.log('my data');
      // console.log(seasonality_dates);
      // console.log(seasonality_spends);

      // const ctx = document.getElementById('canvas');
      this.chart = new Chart('canvas', {
        type: 'line',
        data: {
          labels: [1,2,3,4,5,6],
          datasets: [
            { 
              data: [10,20,30,40,50,60],
              borderColor: "#3cba9f",
              fill: false
            }
          ]
        },
        options: {
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              display: true
            }],
            yAxes: [{
              display: true
            }],
          }
        }
      });
  }

  }



// WEBPACK FOOTER //
// ./src/app/chart/chart.component.ts